import React, { FC } from "react";
import { Platform } from "react-native";

let Modal: FC<any>;

if (Platform.OS !== 'web') {
  Modal = require('react-native').Modal;
} else {
  Modal = require('./WebModal').default;
}

export default Modal